// consistent border radiuses
export const radiuses = {
  none: `1px`,
  small: `4px`,
  medium: `8px`,
  large: `16px`,
  round: `50%`,
  rounded: `50vh`,
} as const

// define same radius for all corners
export type TSingleRadius = keyof typeof radiuses
// define radius for each corner separately
export type TMultiRadius = {
  topLeft: TSingleRadius
  topRight: TSingleRadius
  bottomRight: TSingleRadius
  bottomLeft: TSingleRadius
}
// mostly use this as a prop – allows both single value or an object with values for each corner
export type TRadius = TSingleRadius | TMultiRadius

// transform radius (prop) key to the value(s)
export const getRadiusValue = (radius: TRadius) => {
  if (typeof radius === 'string') {
    return radiuses[radius]
  }

  return `
    ${radiuses[radius.topLeft]} ${radiuses[radius.topRight]}${` `}
    ${radiuses[radius.bottomRight]} ${radiuses[radius.bottomLeft]}
    `
}

type TOptions = {
  radius: TSingleRadius
  paddingValue: string
}

/**
 * Returns radius value (CSS value) of the nested element
 * based on the parent's `radius` and the parent's `paddingValue`
 */
export const getNestedRadiusValue = ({ radius, paddingValue }: TOptions) => {
  if (radius === `round` || radius === `rounded` || radius === `none`) {
    return radius
  }

  const radiusValue = getRadiusValue(radius)

  return `calc(${radiusValue} - ${paddingValue})`
}
